import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectAssignedUsers = createSelector(
  selectLoanApplication,
  ({ assignedUsers }) => assignedUsers,
);
